import { render, staticRenderFns } from "./DiscontinuedSwatches.vue?vue&type=template&id=027e54e8"
import script from "./DiscontinuedSwatches.vue?vue&type=script&lang=js"
export * from "./DiscontinuedSwatches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports